import React from 'react';
import SearchBar from '../components/SearchBar';
import './Home.css';

// Page d'accueil de l'application
// Affiche un titre et une barre de recherche centree
function Home() {
    return (
        <div className="home">
            <div className="home-content">
                {/* Titre de l'application */}
                <h1 className="home-title">
                    <span className="title-miam">Miam</span>
                    <span className="title-miam2">Miam</span>
                </h1>

                {/* Sous-titre explicatif */}
                <p className="home-subtitle">
                    Trouvez votre prochaine recette parmi des milliers de plats
                </p>

                {/* Barre de recherche */}
                <SearchBar />
            </div>
        </div>
    );
}

export default Home;
